import { $view } from '@/stores';
import { useStore } from '@nanostores/react';

export default function LogsTableHeader() {
  const view = useStore($view);

  switch (view) {
    case 'operator':
    case 'officer':
      return (
        <tr>
          <td className="w-1 border border-gray-600 px-4 font-bold text-nowrap">
            Freq.
          </td>
          <td className="w-1 border border-gray-600 px-4 font-bold text-nowrap">
            C/S
          </td>
          <td className="w-1 border border-gray-600 px-4 font-bold text-nowrap">
            Time
          </td>
          <td className="border border-gray-600 px-2 font-bold text-nowrap">
            Description
          </td>
          <td className="w-1 border border-gray-600 px-4 font-bold text-nowrap">
            No.
          </td>
          <td className="w-1 border border-gray-600 px-4 font-bold text-nowrap print:hidden">
            Tags
          </td>
        </tr>
      );
    case 'audit':
      return (
        <tr>
          <th className="w-1 border border-gray-600 font-bold text-nowrap">
            Freq.
          </th>
          <th className="w-1 border border-gray-600 font-bold text-nowrap">
            C/S
          </th>
          <th className="w-1 border border-gray-600 px-4 font-bold text-nowrap">
            Time
          </th>
          <th className="w-1 border border-gray-600 px-4 font-bold text-nowrap">
            Rev T
          </th>
          <th className="border border-gray-600 px-4 font-bold text-nowrap">
            Description
          </th>
          <th className="w-1 border border-gray-600 font-bold text-nowrap">
            No.
          </th>
          <th className="w-1 border border-gray-600 font-bold text-nowrap">
            Rev.
          </th>
        </tr>
      );
  }

  return null;
}
